import React from 'react';
import PropTypes from 'prop-types';
import { head } from 'ramda';
import { isEven } from 'utils/helperMethods';
import { Box } from '@material-ui/core';
import MortgageSurveyPresenter from 'presenters/MortgageSurveyPresenter';
import MortgageSurveyQuestionPresenter from 'presenters/MortgageSurveyQuestionPresenter';
import InfoRow from './components/InfoRow';

import useStyles from './useStyles';

const SurveySummary = props => {
  const { surveyValues, questions } = props;
  const classes = useStyles();

  const FORMATTED_SURVEY_VALUE_MAPPER = {
    priceTarget: values => MortgageSurveyPresenter.readablePriceTarget(values),
    downPaymentTarget: values => MortgageSurveyPresenter.readableDownPaymentTarget(values),
    incomeAnnualPreTax: values => MortgageSurveyPresenter.redableIncomeAnnualPreTax(values),
    creditScore: values => MortgageSurveyPresenter.readableCreditScore(values),
    monthlyDebt: values => MortgageSurveyPresenter.readableMonthlyDebt(values),
    propertyType: values => MortgageSurveyPresenter.redablePropertyType(values),
    occupancy: values => MortgageSurveyPresenter.readableOccupancy(values),
    stage: values => MortgageSurveyPresenter.readableStage(values),
    mortgageTermYears: values => MortgageSurveyPresenter.readableMortgageTermYears(values),
    locationString: values => MortgageSurveyPresenter.locationString(values),
    hadBankrupt: values => MortgageSurveyPresenter.humanHadBankrupt(values),
    hadForeclosure: values => MortgageSurveyPresenter.humanHadForeclosure(values),
    hadMilitaryService: values => MortgageSurveyPresenter.humanHadMilitaryService(values),
    firstTime: values => MortgageSurveyPresenter.humanFirstTime(values),
    reasonMessage: values => MortgageSurveyPresenter.reasonMessage(values),
    mortgageBalance: values => MortgageSurveyPresenter.readableMortgageBalance(values),
    purpose: values => MortgageSurveyPresenter.readablePurpose(values),
    cashOutAmount: values => MortgageSurveyPresenter.readableCashOutAmount(values),
  };

  return (
    <Box className={classes.container}>
      {questions.map(({ label, surveyValueFields }, index) => {
        const isHighlited = isEven(index);
        const field = head(surveyValueFields);
        const value = FORMATTED_SURVEY_VALUE_MAPPER[field](surveyValues);
        return <InfoRow key={field} label={label} value={value} highlited={isHighlited} />;
      })}
    </Box>
  );
};

SurveySummary.propTypes = {
  surveyValues: MortgageSurveyPresenter.shape().isRequired,
  questions: PropTypes.arrayOf(MortgageSurveyQuestionPresenter.shape()).isRequired,
};

export default SurveySummary;



// WEBPACK FOOTER //
// ./src/sharedComponents/BuyerRequestPage/components/SurveySummary/SurveySummary.js